import { CategoryThree } from '../categoryThree/CategoryThree';

export const CategoryThreeNav = () => {
  return <CategoryThree />;
};
